import React, { useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import useAuth from '../../hooks/useAuth';

const ManageAllCar = () => {
    const [loading, setLoading] = useState(true);
    const [services, setServices] = useState([]);
    const { user } = useAuth();
    const history = useNavigate();
    console.log(user);

    useEffect(() => {
        fetch('https://eventmakerserver.herokuapp.com/services')
            .then(res => res.json())
            .then(data => {
                setServices(data);
                setLoading(false);
            })
            .catch(error => toast.error(error.message))
    }, [])

    // HANDLE RESTRICTPERMISSION 
    const restrictPermission = (id) => {
        let matchedID = false;
        for (let i = 0; i < 6; i++) {
            const { _id } = services[i];
            if (id === _id) {
                matchedID = true;
            }
        }
        if (user.email === "admin@admin.com" && matchedID) {
            return true;
        }
        return false;
    }

    // CAR DETELE HANDLER
    const handleDelete = (id) => {
        if (restrictPermission(id)) {
            return swal("Permission restriction!", "As a test-admin, you don't have permission to delete 6 core services. But you can delete your added services.", "info");
        }
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete this service?",
            icon: "warning",
            buttons: [true, "Yes"],
            dangerMode: true,
        }).then(proceed => {
            if (proceed) {
                const url = `https://safe-crag-22535.herokuapp.com/deletedCar/${id}`
                fetch(url, {
                    method: 'DELETE'
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.deletedCount > 0) {
                            toast.success('Car Details Deteled')
                            const remaining = services.filter(car => car?._id !== id)
                            setServices(remaining);
                        }
                    })
                    .catch(err => {
                        swal("Failed!", "Something went wrong! Please try again.", "error", { dangerMode: true })
                    })
            }
        })
    }
    // CAR UPDATE HANDLER
    const handleUpdate = (id) => {
        if (restrictPermission(id)) {
            return swal("Permission restriction!", "As a test-admin, you don't have permission to delete 6 core services. But you can delete your added services.", "info");
        }
        const uri = `update/${id}`;
        history.push(uri)
    }
    return (
        <div>
            <div className="cardHeader">
                <h2>Manage All Car</h2>
                <h2>Total Cars {services.length}</h2>
                <Link to="" className="view-all-btn">View All</Link>
            </div>
            <table>
                <thead>
                    <tr>
                        <td>SL NO</td>
                        <td>Service Photo</td>
                        <td>Service Name</td>
                        <td>Price</td>
                        <td>UPDATE</td>
                        <td>DELETE</td>
                    </tr>
                </thead>
                {loading ? <Spinner animation="border" variant="success" /> :
                    services.map((service, index) => (
                        <tbody>
                            <tr>
                                <td>{index + 1}</td>
                                <td style={{ width: '180px' }}><img src={service.img} style={{ width: '130px', height: '100px', borderRadius: '5px' }} alt="" /> </td>
                                <td>{service.serviceName.toUpperCase()}</td>
                                <td>{service.price}</td>
                                <td><Button onClick={() => handleUpdate(service._id)} variant="warning bg-warning m-1">Update</Button></td>
                                <td><Button onClick={() => handleDelete(service._id)} variant="danger bg-danger text-light m-1">Delete</Button></td>
                            </tr>
                        </tbody>
                    ))}
            </table>
            <Toaster />
        </div>
    );
};

export default ManageAllCar;